// The one-time "new way to play" popup for NameIt Run on the home screen.
export const RUN_LAUNCH_SEEN_KEY = "nameit.runLaunch.seen";
export const RUN_LAUNCH_UNTIL = new Date("2026-11-01T00:00:00Z").getTime();
// A brand-new player's account is minutes old; they meet the main game first
// and hear about Run on a later visit.
const NEW_PLAYER_MS = 60 * 60 * 1000;

export function shouldShowRunLaunch({ now, accountCreatedAt, seen, playedRun }) {
  if (seen || playedRun || now >= RUN_LAUNCH_UNTIL || !accountCreatedAt) return false;
  return now - accountCreatedAt >= NEW_PLAYER_MS;
}
